import { render, staticRenderFns } from "./ZonesIpv6.vue?vue&type=template&id=9854a862&scoped=true&"
import script from "./ZonesIpv6.vue?vue&type=script&lang=js&"
export * from "./ZonesIpv6.vue?vue&type=script&lang=js&"
import style0 from "./ZonesIpv6.vue?vue&type=style&index=0&id=9854a862&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9854a862",
  null
  
)

export default component.exports